import { useParams } from 'react-router-dom';
import type { UseCanvasOrganizationIdResult } from '../types';

// Canvas routes live under /agents/:agentId — that agentId IS the organization
// id the canvas API expects. Every canvas hook takes organizationId explicitly;
// only this hook reads it from the route so the hooks stay testable and
// reusable from thread UIs later.
const useCanvasOrganizationId = (): UseCanvasOrganizationIdResult => {
    const { agentId } = useParams<{ agentId: string }>();
    return { organizationId: agentId as string };
};

export default useCanvasOrganizationId;
